import { render, staticRenderFns } from "./InhabilitacionEstampillasTab.vue?vue&type=template&id=4921cecc&scoped=true&"
import script from "./InhabilitacionEstampillasTab.vue?vue&type=script&lang=js&"
export * from "./InhabilitacionEstampillasTab.vue?vue&type=script&lang=js&"
import style0 from "./InhabilitacionEstampillasTab.vue?vue&type=style&index=0&id=4921cecc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4921cecc",
  null
  
)

export default component.exports